import {
  FormControl,
  Grid,
  MenuItem,
  Select,
  Switch,
  TextField,
} from "@material-ui/core";
import HomePageCard from "../../home/card";
import en from "../../../lang/en-us";
import { logo } from "../../../logo/logos";
import SegmentedControl from "../../common/segmented-control";
import TabPanel from "../../common/TabPanel";

const DEMAT_TABS_ID = "portfolio-demat-tabs";
const FUNDS_TABS_ID = "portfolio-funds-tabs";
const SCHEME_TABS_ID = "portfolio-scheme-tabs";
import { useEffect, useState } from "react";
import ListCards from "../../../lib/ListCards";
import SearchInput from "../../../lib/SearchInput";
import { connect } from "react-redux";
import { getPortfolio } from "../../../redux-store/actions/portfolio";
import {
  PORTFOLIO_DATA_RESPONSE,
  SCHEMES_RESPONSE,
} from "../../../redux-store/types/portfolio";
import { RootStateType } from "../../../redux-store/reducers";
import {
  decimalFix,
  getAssetTypeValues,
  groupByAmcName,
  dematFund,
} from "./utils";
import { useMemo } from "react";
import BarChart from "./bar-graph";
import { formatAsIndianCurrency } from "../../../utils/currency";
import { PieChart } from "../../../lib/PieChar";
import { useCallback } from "react";
import AsyncLoader from "../../../lib/AsyncLoader";
import { Skeleton } from "@material-ui/lab";
import NoFoliosFound from "../makeNct/NoFoliosFound";
import {
  TRANSACTION_RESOURCE_TYPES,
  ZERO_HOLDINGS,
  NON_ZERO_HOLDINGS,
  ALL_HOLDINGS,
} from "../../../utils/constants";
import HoldingTypeRadio from "../../../lib/HoldingTypeRadio";
import { FundInfoDialog, Info } from "../home";
import React from "react";
const {} = en;

const SEGMENTS_MAIN = [
  en.dashboard.portfolioDetails.tabs.assetAllocation,
  en.dashboard.portfolioDetails.tabs.asset,
  en.dashboard.portfolioDetails.tabs.amc,
];

const SCHEME_TYPES = [en.common.equity, en.common.debt, en.common.liquid];

const SCHEME_TYPE_INDEX_MAP: {
  [key: string]: number;
} = {
  equity: 0,
  debt: 1,
  liquid: 2,
};

const SEGMENT_INDEX_MAP = {
  [en.dashboard.portfolioDetails.tabs.assetAllocation]: 0,
  [en.dashboard.portfolioDetails.tabs.asset]: 1,
  [en.dashboard.portfolioDetails.tabs.amc]: 2,
};

const SORT_TYPES = [
  en.dashboard.portfolioDetails.list.holdingPercentage,
  en.dashboard.portfolioDetails.sortbyList.gainLoss,
  en.dashboard.portfolioDetails.sortbyList.marketValue,
  // en.dashboard.portfolioDetails.sortbyList.atoz
];

const BAR_CHART = "BAR_CHART";
const PIE_CHART = "PIE_CHART";

const AmcSkelton = () => {
  return (
    <>
      {new Array(3).fill({}).map((_, index) => (
        <a className="list-cards-single-link">
          <div key={index} className="list-cards-single">
            <div className="list-cards-top">
              <Skeleton
                variant="rect"
                width={50}
                height={50}
                style={{ marginRight: 30 }}
              />
              <h3>
                <Skeleton variant="text" width={300} height={20} />
              </h3>
              <p>
                <Skeleton variant="text" width={200} height={20} />
              </p>
            </div>
            <div className="list-cards-bottom">
              <div className="list-cards-bottom-info">
                <h5>
                  <Skeleton
                    variant="text"
                    width={200}
                    height={20}
                    style={{ marginLeft: 15 }}
                  />
                </h5>
                <p>
                  <Skeleton
                    variant="text"
                    width={100}
                    height={20}
                    style={{ marginLeft: "-10px" }}
                  />
                </p>
              </div>
              <div className="list-cards-bottom-info">
                <h5>
                  <Skeleton variant="text" width={200} height={20} />
                </h5>
                <p>
                  <Skeleton
                    variant="text"
                    width={100}
                    height={20}
                    style={{ marginLeft: "-25px" }}
                  />
                </p>
              </div>
              <div className="list-cards-bottom-info">
                <h5>
                  <Skeleton variant="text" width={200} height={20} />
                </h5>
                <p>
                  <Skeleton
                    variant="text"
                    width={100}
                    height={20}
                    style={{ marginLeft: "-25px" }}
                  />
                </p>
              </div>
            </div>
          </div>
        </a>
      ))}
    </>
  );
};

function Portfolios(props: any) {
  const [isDemat, setIsDemat] = useState<boolean>(false);
  const [mainSegment, setMainSegment] = useState(SEGMENTS_MAIN[0]);
  const [schemeType, setSchemeType] = useState(SCHEME_TYPES[0]);
  const [searchText, setText] = useState<string>("");
  const [sortBy, setSortBy] = useState<any>("NONE");
  const [tempSortBy, setTempSortBy] = useState<any>("NONE");
  const [pieData, setPieData] = useState<any>([]);
  const [chartType, setChartType] = useState<string>(BAR_CHART);
  const [holdingType, setHoldingType] = useState<string>(ALL_HOLDINGS);
  const [fundInfoShow, setFundInfoShow] = useState<boolean>(false);
  const [schemeTypeAnnouncement, setSchemeTypeAnnouncement] =
    useState<string>("");
  const [sortByAnnouncement, setSortByAnnouncement] = useState<string>("");
  const switchRef = React.useRef<HTMLInputElement | null>(null);
  const [bars, setBars] = useState<any>([
    { label: "Liquid", value: 0.0 },
    { label: "Equity", value: 0.0 },
    { label: "Debt", value: 0.0 },
  ]);
  const { portfolio = {} } = props?.portfolios || {};
  useEffect(() => {
    async function fetchPortfolio() {
      try {
        const { pan = "", pekrn = "", mobile = "", reqId = "" } = props;
        await props.getPortfolio({
          pan,
          pekrn,
          mobile,
          reqId,
        });
      } catch (error: any) {
        alert(error.message);
      }
    }
    fetchPortfolio();
  }, []);

  const type = useMemo(() => (isDemat ? "demat" : "non_demat"), [isDemat]);

  let mainSegmentsToDisplay = SEGMENTS_MAIN;

  // Hiding first two tabs for demat
  mainSegmentsToDisplay = mainSegmentsToDisplay.slice(isDemat ? 2 : 0);
  useEffect(() => {
    handleMainSegmentChange(isDemat ? 2 : 0);
  }, [isDemat]);
  // end

  /**
   * Memorized the Portfolios data with mapped demat filter
   */
  const fundByDematAndNonDemat: PORTFOLIO_DATA_RESPONSE[] = useMemo(() => {
    const { data = [], ...portfolioInfo } = props.portfolios;
    const fundByDematFilter = data.reduce(
      (prev: PORTFOLIO_DATA_RESPONSE[], fund: PORTFOLIO_DATA_RESPONSE) => {
        const { schemes, ...rest } = fund;
        let amcSchemes: SCHEMES_RESPONSE[] = [];
        schemes.forEach((scheme: SCHEMES_RESPONSE) => {
          let _isDematFund = dematFund(scheme);
          if (isDemat === _isDematFund) {
            amcSchemes = [...amcSchemes, scheme];
          }
        });
        return [...prev, { ...rest, schemes: amcSchemes }];
      },
      []
    );
    fundByDematFilter.sort((first: any, second: any) => {
      let amcName1 = first?.summary[type]?.amcName.toUpperCase();
      let amcName2 = second?.summary[type]?.amcName.toUpperCase();
      if (amcName1 < amcName2) {
        return -1;
      }
      if (amcName1 > amcName2) {
        return 1;
      }

      return 0;
    });

    return fundByDematFilter;
  }, [props.portfolios, isDemat]);

  // Funds filtering by mkt value (Holding filter)
  const memorizedFilterData = useMemo(
    () =>
      fundByDematAndNonDemat.filter((fund: any) => {
        const value = Number(fund.summary[type]?.currentMktValue);
        if (holdingType === ZERO_HOLDINGS) {
          return value == 0;
        } else if (holdingType === NON_ZERO_HOLDINGS) {
          return value > 0;
        } else {
          return true;
        }
      }),
    [fundByDematAndNonDemat, holdingType]
  );

  /**
   * Effect which can handle to load pie and bar graph
   */
  useEffect(() => {
    const assetTypeData = groupByAmcName(memorizedFilterData);
    if (!!assetTypeData) {
      const result = getAssetTypeValues(assetTypeData);
      if (Object.keys(result).length) {
        const updated = Object.keys(result).map((ele: any) => ({
          label: ele,
          value: result[ele]?.currentMktValue,
        }));
        setBars(updated);
      }
      setPieData(() => {
        let pieData = memorizedFilterData
          .filter((ele: PORTFOLIO_DATA_RESPONSE) => ele.summary[type])
          .map((ele: PORTFOLIO_DATA_RESPONSE) => [
            ele.summary[type]?.amcName,
            Number(ele.summary[type]?.currentMktValue),
            ele.summary[type]?.amc,
          ]);
        pieData.sort((a: any, b: any) => b[1] - a[1]);
        return pieData.slice(0, 10); // For Top 10 amcs
      });
    }
  }, [memorizedFilterData, type]);

  const handleBarChartClick = (schemeType: string) => {
    setMainSegment(SEGMENTS_MAIN[1]);
    setSchemeType(
      SCHEME_TYPES[SCHEME_TYPE_INDEX_MAP[schemeType.toLowerCase()]]
    );
  };

  const applySort = (value: any) => {
    setSortBy(value);
    setTempSortBy(value);
    let label = "default order";
    if (value === 0)
      label = en.dashboard.portfolioDetails.list.holdingPercentage;
    else if (value === 1)
      label = en.dashboard.portfolioDetails.sortbyList.gainLoss;
    else if (value === 2)
      label = en.dashboard.portfolioDetails.sortbyList.marketValue;
    setSortByAnnouncement("");
    window.setTimeout(() => {
      setSortByAnnouncement(`Sorted by ${label}`);
    }, 50);
  };

  const handleSortSubmit = () => {
    applySort(tempSortBy);
  };

  /**
   * Memorized the AssetType/Scheme Type funds
   */
  const memorizedSchemeTypeData = useMemo(() => {
    const assetTypeData = groupByAmcName(fundByDematAndNonDemat);
    let amcData = assetTypeData[schemeType.toLowerCase()] || [];
    amcData.sort((first: any, second: any) => {
      let amcName1 = first.amcName.toUpperCase();
      let amcName2 = second.amcName.toUpperCase();
      if (amcName1 < amcName2) {
        return -1;
      }
      if (amcName1 > amcName2) {
        return 1;
      }

      return 0;
    });
    // sort by holding
    return amcData.filter((fund: any) => {
      const value = Number(fund.currentMktValue);
      if (holdingType === ZERO_HOLDINGS) {
        return value == 0;
      } else if (holdingType === NON_ZERO_HOLDINGS) {
        return value > 0;
      } else {
        return true;
      }
    });
  }, [schemeType, fundByDematAndNonDemat, holdingType]);

  const handleMainSegmentChange = (selectedIndex: number) => {
    setMainSegment(SEGMENTS_MAIN[selectedIndex]);
    setHoldingType(ALL_HOLDINGS);
  };

  const setActiveScheme = (selectedIndex: number) => {
    const newSchemeType = SCHEME_TYPES[selectedIndex];
    setSchemeType(newSchemeType);
    setSchemeTypeAnnouncement(`Now showing ${newSchemeType} schemes`);
  };

  const handleActiveScheme = (selectedIndex: number) => {
    setActiveScheme(selectedIndex);
    // Move focus into the tab panel (which is AFTER the tabs in DOM order)
    // so Shift+Tab returns through Liquid -> Debt -> Equity as expected.
    setTimeout(() => {
      const panel = document.getElementById(
        `${SCHEME_TABS_ID}-tabpanel-${selectedIndex}`
      );
      if (panel) {
        (panel as HTMLElement).focus();
      }
    }, 100);
  };

  /**
   * Memorized Amc list with applied Filters;
   */
  const sortedAmclist = useMemo(() => {
    if (!!memorizedFilterData.length) {
      let amcsList = [...memorizedFilterData] || [];
      if (sortBy === 0) {
        // Sort By Holding percentage
        amcsList.sort(
          (first: PORTFOLIO_DATA_RESPONSE, second: PORTFOLIO_DATA_RESPONSE) => {
            let holding1 = decimalFix(
              (Number(first.summary[type]?.currentMktValue) * 100) /
                Number(props.portfolios.portfolio[type]?.currentMktValue)
            );
            let holding2 = decimalFix(
              (Number(second.summary[type]?.currentMktValue) * 100) /
                Number(props.portfolios.portfolio[type]?.currentMktValue)
            );
            return holding2 - holding1;
          }
        );
      } else if (sortBy === 1) {
        // Sort by Gain or Loss
        amcsList.sort(
          (first: PORTFOLIO_DATA_RESPONSE, second: PORTFOLIO_DATA_RESPONSE) =>
            second.summary[type]?.gainLossPercentage -
            first.summary[type]?.gainLossPercentage
        );
      } else if (sortBy === 2) {
        // Sort by Invested Value
        amcsList.sort(
          (first: PORTFOLIO_DATA_RESPONSE, second: PORTFOLIO_DATA_RESPONSE) =>
            second.summary[type]?.costValue - first.summary[type]?.costValue
        );
      } else {
        // Any more conditions
      }
      return amcsList;
    }
    return [];
  }, [sortBy, memorizedFilterData, type]);

  const amc_data = sortedAmclist.filter(
    (ele: PORTFOLIO_DATA_RESPONSE) =>
      ele?.summary[type] &&
      (ele?.summary[type]?.amcName || "")
        .toLocaleLowerCase()
        .includes(searchText.toLowerCase())
  );
  const renderSegement = () => {
    const mainIndex = SEGMENT_INDEX_MAP[mainSegment];
    const mainPanelId = `${FUNDS_TABS_ID}-tabpanel-${mainIndex}`;
    const mainPanelLabelledBy = `${FUNDS_TABS_ID}-tab-${mainIndex}`;
    switch (mainSegment) {
      case SEGMENTS_MAIN[0]: {
        return (
          <TabPanel id={mainPanelId} labelledBy={mainPanelLabelledBy}>
            <Grid
              container
              spacing={0}
              xs={12}
              className="db-grid-boxes db-portfolio-grid"
            >
              <Grid item xs={12} md={8}>
                <HomePageCard className="db-grid-portfolio-chart">
                  <>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div className="db-portfolio-chart-toggle">
                        <p
                          style={chartType === BAR_CHART ? { opacity: 1 } : {}}
                          aria-hidden="true"
                        >
                          By Asset Class{" "}
                        </p>
                        <span
                          className="chart-toggle-switch-wrapper"
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <Switch
                            inputRef={switchRef}
                            name="toggle-chart"
                            focusVisibleClassName="switch-focus-visible"
                            inputProps={{
                              role: "switch",
                              "aria-label": `Chart view, ${
                                chartType === BAR_CHART
                                  ? "By Asset Class"
                                  : "By Fund House"
                              }`,
                              "aria-checked":
                                chartType === PIE_CHART ? "true" : "false",
                            }}
                            value={chartType}
                            checked={chartType !== BAR_CHART}
                            onChange={() =>
                              setChartType((t) =>
                                t === BAR_CHART ? PIE_CHART : BAR_CHART
                              )
                            }
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                e.preventDefault();
                                setChartType((t) =>
                                  t === BAR_CHART ? PIE_CHART : BAR_CHART
                                );
                              }
                            }}
                          />
                        </span>
                        <p
                          style={chartType === PIE_CHART ? { opacity: 1 } : {}}
                          aria-hidden="true"
                        >
                          By Fund House
                        </p>
                      </div>
                    </div>
                    <div className="db-portfolio-chart-content">
                      {chartType === BAR_CHART ? (
                        <>
                          <BarChart
                            bars={[...bars]}
                            handleBarChartClick={handleBarChartClick}
                          />
                          <span className="bar-chart-line"></span>
                        </>
                      ) : (
                        <PieChart
                          totalValue={pieData.reduce(
                            (prev: number, curr: Array<any>) => {
                              return curr[1] + prev;
                            },
                            0
                          )}
                          data={pieData}
                          title={"Top 10 Funds"}
                        />
                      )}
                    </div>
                  </>
                </HomePageCard>
              </Grid>
              <Grid item xs={12} md={4}>
                <HomePageCard className="db-grid-portfolio-info">
                  <div className="db-grid-boxes-info db-grid-boxes-info-white">
                    <h5>{en.dashboard.dbPortfolio.bottom.heading}</h5>
                    <p>{en.dashboard.dbPortfolio.bottom.info}</p>
                    {/* <a
                    href="https://www.etmoney.com/blog/scenarios-when-you-should-rebalance-your-portfolio/"
                    target="_blank"
                  >
                    {en.dashboard.dbPortfolio.bottom.link}{" "}
                    <img src="/images/right-arrow-white.svg" alt="" aria-hidden="true" />
                  </a> */}
                    <img src="/images/yellow-bulb.svg" alt="" />
                  </div>
                </HomePageCard>
              </Grid>
            </Grid>
          </TabPanel>
        );
      }
      case SEGMENTS_MAIN[1]: {
        return (
          <TabPanel
            id={mainPanelId}
            labelledBy={mainPanelLabelledBy}
            className="portfolio-details"
          >
            <div
              className="portfolio-details-tabs-content"
              aria-live="polite"
              aria-atomic="true"
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  const switchElement =
                    document.querySelector('[role="switch"]');
                  if (switchElement) {
                    (switchElement as HTMLElement).focus();
                  }
                }
              }}
            >
              <div
                className="sr-only"
                role="status"
                aria-live="assertive"
                aria-atomic="true"
              >
                {schemeTypeAnnouncement}
              </div>
              <HoldingTypeRadio
                selectedValue={holdingType}
                handleRadioChange={(value: any) => setHoldingType(value)}
              />
              <div className="portfolio-details-asset">
                <div className="portfolio-vertical-tabs">
                  <ul
                    className={`link${
                      SCHEME_TYPES.findIndex((value) => value === schemeType) +
                      1
                    }`}
                    role="tablist"
                    aria-label="Scheme type"
                  >
                    {SCHEME_TYPES.map((ele: any, ind: number) => (
                      <li key={ele} role="presentation">
                        <a
                          href="#"
                          className={ele === schemeType ? "active" : ""}
                          onClick={(e) => {
                            e.preventDefault();
                            handleActiveScheme(ind);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              e.preventDefault();
                              handleActiveScheme(ind);
                              return;
                            }
                            const last = SCHEME_TYPES.length - 1;
                            let nextIdx: number | null = null;

                            if (
                              e.key === "ArrowDown" ||
                              e.key === "ArrowRight"
                            ) {
                              nextIdx = ind === last ? 0 : ind + 1;
                            } else if (
                              e.key === "ArrowUp" ||
                              e.key === "ArrowLeft"
                            ) {
                              nextIdx = ind === 0 ? last : ind - 1;
                            } else if (e.key === "Home") {
                              nextIdx = 0;
                            } else if (e.key === "End") {
                              nextIdx = last;
                            }

                            if (nextIdx !== null) {
                              e.preventDefault();
                              setActiveScheme(nextIdx);
                              const nextTab = document.getElementById(
                                `${SCHEME_TABS_ID}-tab-${nextIdx}`
                              );
                              nextTab?.focus();
                            }
                          }}
                          role="tab"
                          aria-selected={ele === schemeType}
                          aria-controls={`${SCHEME_TABS_ID}-tabpanel-${ind}`}
                          id={`${SCHEME_TABS_ID}-tab-${ind}`}
                          tabIndex={ele === schemeType ? 0 : -1}
                        >
                          {ele}
                          {ele !== schemeType && (
                            <span className="sr-only">, not selected</span>
                          )}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
                <TabPanel
                  id={`${SCHEME_TABS_ID}-tabpanel-${SCHEME_TYPES.indexOf(
                    schemeType
                  )}`}
                  labelledBy={`${SCHEME_TABS_ID}-tab-${SCHEME_TYPES.indexOf(
                    schemeType
                  )}`}
                  className={
                    !!memorizedSchemeTypeData ? "list-cards" : "no-list-cards"
                  }
                >
                  <AsyncLoader
                    skelton={<AmcSkelton />}
                    data={props?.portfolios?.portfolio}
                  >
                    {memorizedSchemeTypeData.length ? (
                      memorizedSchemeTypeData.map(
                        (ele: SCHEMES_RESPONSE, ind: number) => {
                          const gainLoss =
                            Number(ele.currentMktValue) - Number(ele.costValue);
                          const gainLossPercentage =
                            gainLoss !== 0
                              ? (Number(gainLoss) * 100) /
                                Number(ele.costValue || 1)
                              : 0;
                          const isLastCard =
                            ind === memorizedSchemeTypeData.length - 1;
                          const currentSchemeIndex =
                            SCHEME_TYPES.indexOf(schemeType);
                          const hasNextScheme =
                            currentSchemeIndex < SCHEME_TYPES.length - 1;

                          return (
                            <ListCards
                              key={ele.schemeType + ind}
                              navigationAction={() =>
                                props.history.push(
                                  `/portal/portfolio-scheme-details/${ele.amc}`,
                                  { type, assetType: schemeType }
                                )
                              }
                              icon={logo[ele.amc]}
                              fund={ele.amcName || ""}
                              holding={decimalFix(
                                (Number(ele.currentMktValue) * 100) /
                                  Number(
                                    props.portfolios.portfolio[type]
                                      ?.currentMktValue
                                  )
                              )}
                              investedValue={formatAsIndianCurrency(
                                Number(ele.costValue)
                              )}
                              marketValue={formatAsIndianCurrency(
                                Number(ele.currentMktValue)
                              )}
                              gainLoss={formatAsIndianCurrency(gainLoss)}
                              gainLossPercent={decimalFix(gainLossPercentage)}
                              isLastCard={isLastCard}
                              onNextScheme={() => {
                                if (isLastCard && hasNextScheme) {
                                  handleActiveScheme(currentSchemeIndex + 1);
                                }
                              }}
                            />
                          );
                        }
                      )
                    ) : (
                      <NoFoliosFound info={en.common.noRecordsFound} />
                    )}
                  </AsyncLoader>
                </TabPanel>
              </div>
            </div>
          </TabPanel>
        );
      }
      case SEGMENTS_MAIN[2]: {
        return (
          <TabPanel
            id={mainPanelId}
            labelledBy={mainPanelLabelledBy}
            className="portfolio-details"
          >
            <div
              className="portfolio-details-tabs-content"
              aria-live="polite"
              aria-atomic="true"
              onKeyDown={(e) => {
                if (e.key === "Escape") {
                  const switchElement =
                    document.querySelector('[role="switch"]');
                  if (switchElement) {
                    (switchElement as HTMLElement).focus();
                  }
                }
              }}
            >
              <div className="portfolio-details-amc">
                <div className="portfolio-details-filter">
                  <SearchInput
                    onChange={(e: any) => setText(e.target.value)}
                    value={searchText}
                    id="search-amc"
                    placeholder="Search Fund House"
                    darkmode={true}
                  />
                  <div
                    role="status"
                    aria-live="polite"
                    aria-atomic="true"
                    style={{
                      position: "absolute",
                      left: "-10000px",
                      width: "1px",
                      height: "1px",
                      overflow: "hidden",
                    }}
                  >
                    {memorizedFilterData.length}{" "}
                    {memorizedFilterData.length === 1 ? "result" : "results"}{" "}
                    found
                  </div>
                  <div className="portfolio-details-sortby">
                    <p id="portfolio-sortby-label" aria-hidden="true">
                      {en.dashboard.portfolioDetails.sortby} :
                    </p>
                    <div
                      className="sr-only"
                      role="status"
                      aria-live="assertive"
                      aria-atomic="true"
                    >
                      {sortByAnnouncement}
                    </div>
                    <FormControl variant="filled">
                      <Select
                        id="portfolio-sortby"
                        inputProps={{
                          "aria-label": `${en.dashboard.portfolioDetails.sortby}. Selecting an option will sort the portfolio list immediately.`,
                        }}
                        onChange={({ target: { value } }) => applySort(value)}
                        value={tempSortBy}
                      >
                        <MenuItem value="NONE">Select</MenuItem>
                        {SORT_TYPES.map((type: string, index: number) => (
                          <MenuItem value={index} key={index}>
                            {type}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <button
                      type="button"
                      onClick={handleSortSubmit}
                      className="sr-only"
                      aria-label="Apply selected sort option"
                      tabIndex={-1}
                      aria-hidden="true"
                    >
                      Apply Sort
                    </button>
                  </div>
                </div>
                <HoldingTypeRadio
                  selectedValue={holdingType}
                  handleRadioChange={(value: any) => setHoldingType(value)}
                />
                <div className="list-cards">
                  <AsyncLoader
                    skelton={<AmcSkelton />}
                    data={props?.portfolios?.portfolio}
                  >
                    <>
                      {amc_data.length ? (
                        amc_data.map(
                          (ele: PORTFOLIO_DATA_RESPONSE, index: any) =>
                            ele.summary[type] && (
                              <ListCards
                                key={index}
                                href={`/portal/portfolio-scheme-details/${ele.summary[type]?.amc}`}
                                navigationAction={() =>
                                  props.history.push(
                                    `/portal/portfolio-scheme-details/${ele.summary[type]?.amc}`,
                                    { type }
                                  )
                                }
                                icon={logo[ele.summary[type]?.amc]}
                                fund={ele.summary[type]?.amcName}
                                holding={decimalFix(
                                  (Number(ele.summary[type]?.currentMktValue) *
                                    100) /
                                    Number(
                                      props.portfolios.portfolio[type]
                                        ?.currentMktValue
                                    )
                                )}
                                investedValue={formatAsIndianCurrency(
                                  ele.summary[type]?.costValue
                                )}
                                marketValue={formatAsIndianCurrency(
                                  ele.summary[type]?.currentMktValue
                                )}
                                gainLoss={formatAsIndianCurrency(
                                  ele.summary[type]?.gainLoss
                                )}
                                gainLossPercent={
                                  ele.summary[type]?.gainLossPercentage
                                }
                              />
                            )
                        )
                      ) : (
                        <NoFoliosFound info={en.common.noRecordsFound} />
                      )}
                    </>
                  </AsyncLoader>
                </div>
              </div>
            </div>
          </TabPanel>
        );
      }
      default:
        return null;
    }
  };

  const DematSegment = useCallback(
    () => (
      <SegmentedControl
        id={DEMAT_TABS_ID}
        ariaLabel="Holding type"
        additionalClasses="portfolio-details-tabs portfolio-demat-tabs"
        segments={TRANSACTION_RESOURCE_TYPES}
        onSegmentChanged={(index) => setIsDemat(!!index)}
        selectedSegmentIndex={isDemat ? 1 : 0}
      />
    ),
    [isDemat]
  );

  const FundsSegments = useCallback(
    () => (
      <SegmentedControl
        id={FUNDS_TABS_ID}
        ariaLabel="Portfolio breakdown"
        additionalClasses="portfolio-details-tabs portfolio-details-main-tab"
        selectedSegmentIndex={SEGMENT_INDEX_MAP[mainSegment]}
        segments={mainSegmentsToDisplay}
        onSegmentChanged={handleMainSegmentChange}
      />
    ),
    [mainSegmentsToDisplay.length, schemeType]
  );

  const dematPanelIndex = isDemat ? 1 : 0;

  return (
    <div className="portfolio-page">
      <DematSegment />
      <TabPanel
        id={`${DEMAT_TABS_ID}-tabpanel-${dematPanelIndex}`}
        labelledBy={`${DEMAT_TABS_ID}-tab-${dematPanelIndex}`}
      >
        <HomePageCard className="db-banner db-portfolio">
          <>
            <img
              className="db-banner-character"
              src="/images/portfolio-banner-character.png"
              alt=""
            />

            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: 30,
              }}
            >
              <h3 style={{ marginBottom: 0 }}>
                {en.dashboard.dbPortfolio.banner.heading}{" "}
                <b>{en.dashboard.dbPortfolio.banner.headingBold}</b>
              </h3>
              <Info
                info="portfolio"
                onClick={() => setFundInfoShow((prev) => !prev)}
              />
            </div>
            {isDemat && (
              <div className="demat-holding-note">
                <p>{en.dashboard.dematHoldingNote.info1}</p>
                <p>{en.dashboard.dematHoldingNote.info2}</p>
              </div>
            )}
            <div className="db-portfolio-bottom">
              <div className="db-portfolio-info">
                <h6>{en.dashboard.dbPortfolio.investedvalue}</h6>
                <AsyncLoader data={portfolio[type]?.costValue}>
                  <p>{formatAsIndianCurrency(portfolio[type]?.costValue)}</p>
                </AsyncLoader>
              </div>
              <div className="db-portfolio-info">
                <h6>{en.dashboard.dbPortfolio.marketvalue}</h6>
                <AsyncLoader data={portfolio[type]?.currentMktValue}>
                  <p>
                    {formatAsIndianCurrency(portfolio[type]?.currentMktValue)}
                  </p>
                </AsyncLoader>
              </div>
              <div className="db-portfolio-info">
                <h6>{en.dashboard.dbPortfolio.gainLoss}</h6>
                <AsyncLoader data={portfolio[type]?.gainLossPercentage}>
                  <p>
                    {formatAsIndianCurrency(portfolio[type]?.gainLoss)}
                    <span>
                      <img
                        src={
                          Number(portfolio[type]?.gainLossPercentage) < 0
                            ? "/images/loss.svg"
                            : "/images/profit.svg"
                        }
                        alt=""
                      />{" "}
                      {Number(portfolio[type]?.gainLossPercentage) > 0
                        ? `+ ${portfolio[type]?.gainLossPercentage}`
                        : portfolio[type]?.gainLossPercentage}{" "}
                      %
                    </span>
                  </p>
                </AsyncLoader>
              </div>
            </div>
          </>
        </HomePageCard>
        <FundsSegments />
        {/* <renderSegement/> */}
        {renderSegement()}
      </TabPanel>
      <FundInfoDialog
        fundInfoShow={fundInfoShow}
        setFundInfoShow={setFundInfoShow}
      />
    </div>
  );
}

export default connect(
  ({ authReducer, portfolio }: RootStateType) => ({
    ...authReducer,
    ...portfolio,
  }),
  {
    getPortfolio,
  }
)(Portfolios);
